import { render, staticRenderFns } from "./SimpleSurveyTemplateBuilder.vue?vue&type=template&id=64093d60&scoped=true"
import script from "./SimpleSurveyTemplateBuilder.vue?vue&type=script&lang=js"
export * from "./SimpleSurveyTemplateBuilder.vue?vue&type=script&lang=js"
import style0 from "./SimpleSurveyTemplateBuilder.vue?vue&type=style&index=0&id=64093d60&prod&lang=scss&scoped=true"
import style1 from "./SimpleSurveyTemplateBuilder.vue?vue&type=style&index=1&id=64093d60&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64093d60",
  null
  
)

export default component.exports